<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="0"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
</v-snackbar>
<v-layout>
  <v-flex class="text-xs-right">
    <v-btn color="#7BC243" to="/farmers/farmers" class="white--text cataloguebtn">View All Farmers </v-btn>
  </v-flex>
</v-layout>
<v-layout>
<v-flex xs12>
  <div :class="paginatedItems.length === 7 ? 'catalogued_box' : 'catalogued_box_empty'">
    <v-card-text>
    <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Farmers </h5>
    <table class="table">
      <thead class="thead">
        <tr>
          <th scope="col">Grower Code</th>
          <th scope="col">Name</th>
          <th scope="col">Member Number</th>
          <th scope="col">ID Number</th>
          <th scope="col">Mobile Number</th>
          <th scope="col">Acreage</th>
          <th scope="col">Account No.</th>
          <th scope="col">Bank Code</th>
          <th scope="col">Bank Name</th>
          <th scope="col">Farmer Type</th>
          </tr>
      </thead>
      <tbody>
        <tr v-for="item in paginatedItems" v-bind:key="item.id">
          <td> {{ item.growerCode }} </td>
          <td> {{ item.fullName }}</td>
          <td> {{ item.memberNumber }} </td>
          <td> {{ item.farmerId }}</td>
          <td>{{ item.mobileNumber }}</td>
          <td>{{ item.acreage }}</td>
          <td>{{ item.bankAccount }}</td>
          <td>{{ item.bankCode }}</td>
          <td>{{ item.bankName }}</td>
          <td>{{ item.farmerType?.name }}</td>
<!--          <td>{{ item.farmerType.name }}</td>-->
          </tr>
      </tbody>
    </table>
    </v-card-text>
    <v-card-actions>
      <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
      <v-spacer></v-spacer>
      <v-pagination
      v-model="page"
      :length="numberOfLinks"
      :total-visible="7"
      color="secondary"
                class="accent--text logoutbtn"
    ></v-pagination>
    </v-card-actions>
  </div>
</v-flex>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
export default {
	name: 'farmer_details',
	data: function () {
		return {
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			paginatedItems: [],
			permissions: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			documentId: 0
		}
	},
	watch: {
		items: function () {
			this.numberOfLinks = Math.ceil(this.items.length / this.numberOfItemsPerPage)
			this.paginatedItems = this.paginationMethod(this.items, 1, this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedItems = this.paginationMethod(this.items, val, this.numberOfItemsPerPage)
		}
	},
	mounted () {
		this.getFarmerDetails()
		this.documentId = this.$route.params.id
		this.permissions = store.state.user.roleId.permissions
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getFarmerDetails () {
			const url = config.serverURI + '/upload/cherry/farmer/' + this.$route.params.id
			console.log(url)
			axios.get(url)
				.then(response => {
					this.items = response.data
				})
				.catch(error => {
					console.log('error', error.response)
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		}
	}
}

</script>
<style>
.catalogued_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogued_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.catalogued_box:after, .catalogued_box:before {
  right: 100%;
  top: 23%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogued_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogued_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
</style>
